import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum WithdrawalTypes {
  Default = "default",
  Custom = "custom",
}

export interface WithdrawalIndex {
  name: string;
  percentFromIndex: number;
}

interface WithdrawalStateType {
  withdrawalType: string;
  percentFromPortfolio?: number;
  indexes?: WithdrawalIndex[];
  withdrawalSuccess: boolean;
}

let initialState: WithdrawalStateType = {
  withdrawalType: WithdrawalTypes.Default,
  percentFromPortfolio: 0,
  indexes: [],
  withdrawalSuccess: false,
};

const withdrawalSlice = createSlice({
  name: "withdrawalStoreModule",
  initialState,
  reducers: {
    changeWithdrawalType: (state, action) => {
      state.withdrawalType = action.payload;
    },
    changeWithdrawalPercent: (state, action) => {
      state.percentFromPortfolio = action.payload;
    },
    changeWithdrawalIndexes: (state, action) => {
      state.indexes = action.payload;
    },
    clearWithdrawalState: (state) => {
      state.percentFromPortfolio = initialState.percentFromPortfolio;
      state.indexes = initialState.indexes;
      state.withdrawalSuccess = initialState.withdrawalSuccess;
    },
    setSuccess: (state, action) => {
      state.withdrawalSuccess = action.payload;
    }
  },
});

export const { changeWithdrawalType, changeWithdrawalPercent, changeWithdrawalIndexes, setSuccess, clearWithdrawalState } = withdrawalSlice.actions;

export const WithdrawalReducer = withdrawalSlice.reducer;
